<template>
  <div class="vx-row">
    <vs-card :class="{'border-solid border-primary': isSelf}">
      <!-- <div slot="header" v-if="typeof item.service != 'undefined'">
        <div class="px-3 flex flex-col justify-center ">
            <div class="text-lg font-semibold flex">
              <div class="mr-2">
                {{item.service.agency.name}}
              </div>
            </div>
            <div class="text-lg font-base flex">
              <div class="mr-2">
                 {{item.service.name}}
              </div>
            </div>
          </div>
      </div>-->
      <div class="flex flex-row">
        <div class="flex flex-col flex-1" v-if="item != null">
          <div class="flex items-center">
            <div class="pr-3">
              <vs-avatar
                size="large"
                class="text-lg"
                :color="generateColor(item.customer_name)"
                :text="item.customer_name"
              />
            </div>
            <div>
              <div class="text-lg font-semibold flex items-center">
                <div class="mr-2">{{ item.ticket_code }}</div>
                <vs-chip class="float-right" v-if="item.status == 'skipped'">
                  <vs-avatar icon-pack="feather" color="white" text-color="danger" icon="icon-x" />
                  <span class="text-danger">Dilewati</span>
                </vs-chip>
                <vs-chip class="float-right" color v-if="item.status == 'waiting'">
                  <vs-avatar icon-pack="feather" color="white" text-color icon="icon-clock" />
                  <span>Menunggu Antrian</span>
                </vs-chip>
                <vs-chip class="float-right" color v-if="item.status == 'on_service'">
                  <vs-avatar
                    icon-pack="feather"
                    color="white"
                    text-color="primary"
                    icon="icon-heart"
                  />
                  <span class="text-primary">Dilayani</span>
                </vs-chip>
                <vs-chip class="float-right" color v-if="item.status == 'calling'">
                  <vs-avatar
                    icon-pack="feather"
                    color="white"
                    text-color="#3EC9D6"
                    icon="icon-phone-call"
                  />
                  <span class="text-blue-ocean">Dipanggil</span>
                </vs-chip>
                <vs-chip class="float-right" color v-if="item.status == 'finished'">
                  <vs-avatar
                    icon-pack="feather"
                    color="white"
                    text-color="success"
                    icon="icon-check"
                  />
                  <span class="text-success">Selesai</span>
                </vs-chip>
              </div>
              <div class="text-base flex items-center">
                <vx-tooltip text="Mandiri" class="pr-2" v-if="item.is_priority == 1">
                  <vs-icon icon-pack="feather" icon="icon-star" color="primary"></vs-icon>
                </vx-tooltip>
                {{ item.customer_name }}
              </div>
              <div
                class="text-base flex items-center"
                :class="{ 'text-primary': item.is_self }"
                v-if="typeof item.cluster != 'undefined'"
              >
                <vx-tooltip text="Waktu Kunjungan" class="pr-2">
                  <vs-icon icon-pack="feather" icon="icon-clock" color="primary"></vs-icon>
                </vx-tooltip>
                {{ item.cluster.start_time+" - "+item.cluster.end_time }}
              </div>
            </div>
          </div>
        </div>
        <div class="flex flex-col flex-1" v-else>
          <div class="flex items-center" v-if="!hasSlot('item-empty')">
            <div class="pr-3">
              <vs-avatar size="large" class="text-lg" />
            </div>
            <div>
              <div class="text-lg font-semibold flex items-center">
                <div class="mr-2">Data Kosong</div>
              </div>
              <div class="text-base flex items-center">Data Kosong</div>
            </div>
          </div>
          <slot v-else name="item-empty"></slot>
        </div>
        <div class="text-3xl px-3 flex flex-col justify-center">
          <span v-if="!hasSlot('action')">#{{index + 1}}</span>
          <slot v-else name="action"></slot>
        </div>
      </div>
    </vs-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      color: ["primary", "warning", "success"]
    };
  },
  props: {
    item: {
      type: Object
    },
    type: {
      default: "customer"
    },
    index: {
      required: true
    },
    isSelf: {
      default: false
    }
  },
  methods: {
    hasSlot(name = "default") {
      return !!this.$slots[name] || !!this.$scopedSlots[name];
    },
    generateColor(str, s = 50, l = 70) {
      var hash = 0;
      for (var i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
      }

      var h = hash % 360;
      return "hsl(" + h + ", " + s + "%, " + l + "%)";
    }
  }
};
</script>
